import React from 'react';
import Link from 'gatsby-link';
import { Container, Icon, Divider } from 'semantic-ui-react';

import '../styles/footer.scss';

const Footer = () => (
  <footer>
    <Container className="footer-nav" textAlign="center">
      <Divider />
      <p>
        <a target="_blank" className="footer-nav__link" href="#">
          <Icon size="large" name="facebook" />
        </a>
        <a target="_blank" className="footer-nav__link" href="https://twitter.com/pmena2018sc">
          <Icon size="large" name="twitter" />
        </a>
      </p>
      <p> <Link className="footer-nav__link" to='about'>About</Link> | <a className="footer-nav__link" href="mailto:pmena2018sc@gmail.com" target="_blank">Contact</a> | <Link className="footer-nav__link" to='FAQ'>FAQ</Link> </p>
      <p>
        for more information contact PMENA at{' '}
        <a className="footer-nav__link" target="_blank" href="mailto:pmena2018sc@gmail.com">pmena2018sc@gmail.com</a>
      </p>
      <p>
        <Icon name="copyright" />2018 PME-NA
      </p>
      <p className="footer-nav__attribution">
        {' '}
        This site made with <Icon name="heart" /> by <a target="_blank" rel="noreferrer noopener" href="https://paultallen.com">Paul Allen</a>
      </p>
    </Container>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js